/*
 * @Author: your name
 * @Date: 2022-02-06 15:40:03
 * @LastEditTime: 2022-08-16 16:52:09
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyTextEditor\index.jsx
 */

import React, { Component } from 'react'
import { BsyUtils } from '../../utils/Utils';
import BsyDatePicker from '../BsyDatePicker';
import { BsyWidget } from '../BsyWidget';
import './index.css'
import { dayjsUtils } from '../../utils/dayjsUtils';

export default class BsyDateTimeRange extends BsyWidget {

  constructor(props) {
    super({
      baseCls: "bsy-date-range",
      width4number: 150,
      height: '100%',
      ...props
    })
    this.state = {
      value: this.options.value,
      maxMinValue: null, //后一个时间的最小值限制
      minMaxValue: null, //前一个时间的最大值限制
      startActive: true,
    }
    this.minRealValue = this.state?.value?.min ?
      BsyUtils.date2Str(dayjsUtils.timeToTZ(this.state.value.min), this.options.format) : null;
    this.maxRealValue = this.state?.value?.max ?
      BsyUtils.date2Str(dayjsUtils.timeToTZ(this.state.value.max), this.options.format) : null;
  }



  getValue = () => {
    let a = this.getRValue(this.state.value ? this.state.value.max : null, 'max')
      , b = this.getRValue(this.state.value ? this.state.value.min : null, 'min')
      , c = {};
    BsyUtils.isNull(b) || (c.min = b === '' ? null : b);
    BsyUtils.isNull(a) || (c.max = a === '' ? null : a);
    return c
  }

  getContextMin = (context) => {
    this.min = context
  }


  getContextMax = (context) => {
    this.max = context
  }

  getRValue = (a, type, mode = "") => {
    const { format } = this.options;
    switch (format) {

      case "yyyy-MM-dd HH:mm:ss": {
        if (!BsyUtils.isObjectEmpty(a)) {
          let d = new Date(a);
          if (mode === "text") {
            return BsyUtils.date2Str(d, format)
          }
          return d.getTime()
        }
        break;
      }
      case "yyyy-MM":
        {
          if (!BsyUtils.isObjectEmpty(a)) {
            let d = new Date(a);
            d.setDate(1);
            if (mode === "text") {
              return BsyUtils.date2Str(d, format)
            }
            if (type === 'min') {
              let d = new Date(a);
              d.setDate(1);
              d.setHours(0, 0, 0, 0)
              if (mode === "text") {
                return BsyUtils.date2Str(d, format)
              }
              return d.getTime();
            }
            else {
              let e = new Date(a);
              let m = e.getMonth();
              d.setMonth(m + 1, 1);
              d.setHours(0, 0, 0, 0)
              d.setMilliseconds(-1);
              if (mode === "text") {
                return BsyUtils.date2Str(d, format)
              }
              return d.getTime();
            }
          }
          break;
        }
      case "yyyy":
        {
          if (!BsyUtils.isObjectEmpty(a)) {
            if (type === 'min') {
              let d = new Date(a);
              d.setMonth(0, 1);
              d.setHours(0, 0, 0, 0)
              if (mode === "text") {
                return BsyUtils.date2Str(d, format)
              }
              return d.getTime()
            } else {
              let d = new Date(a);
              let y = d.getFullYear();
              d.setFullYear(y + 1, 0, 1);
              d.setHours(0, 0, 0, 0);
              d.setMilliseconds(-1);
              if (mode === "text") {
                return BsyUtils.date2Str(d, format)
              }
              return d.getTime();
            }

          }
          break;
        }
      case "yyyy-MM-dd":
      default: {
        if (!BsyUtils.isObjectEmpty(a)) {
          if (type === 'min') {
            let d = new Date(a);
            d.setHours(0, 0, 0, 0)
            if (mode === "text") {
              return BsyUtils.date2Str(d, format)
            }
            return d.getTime()
          } else {
            let d = new Date(a);
            d.setHours(23, 59, 59, 999)
            if (mode === "text") {
              return BsyUtils.date2Str(d, format)
            }
            return d.getTime()
          }
        }
        break;
      }
    }
    return null;
  }

  getRealValue = () => {
    let a = this.getRValue(this.maxRealValue, 'max', "text")
      , b = this.getRValue(this.minRealValue, 'min', "text")
      , c = {};
    BsyUtils.isObjectEmpty(b) || (c.min = b === '' ? null : b);
    BsyUtils.isObjectEmpty(a) || (c.max = a === '' ? null : a);
    return c
  }

  render() {
    let that = this;
    const { cssName, width4number, format } = this.options;
    const { value, maxMinValue, minMaxValue, startActive } = this.state
    let css = {
      width: this.options.width,
      height: this.options.height,
    }
    return (
      <div className={cssName} style={css} ref={this.element}>
        <div className={'range-content ' + (!startActive ? 'right' : '')}>
          <div className="content-menu">
            <div className="menu-item start" onClick={() => {
              this.setState({
                startActive: true
              })
            }}>
              {
                value.min && <><div className="item-text">{this.minRealValue}</div><i className="icon-close-circle"
                  onClick={() => {
                    this.setState({
                      maxMinValue: null,
                      value: {
                        min: null,
                        max: this.state.value.max
                      }
                    }, () => {
                      BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
                    })
                  }}
                ></i></>
              }
              {
                !value.min && <div className="watermark">{React.language('timeBegin')}</div>
              }
            </div>
            <div className="menu-item end " onClick={() => {
              this.setState({
                startActive: false
              })
            }}>
              {
                value.max && <><div className="item-text">{this.maxRealValue}</div><i className="icon-close-circle"
                  onClick={() => {
                    this.setState({
                      minMaxValue: null,
                      value: {
                        max: null,
                        min: this.state.value.min
                      }
                    }, () => {
                      BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
                    })
                  }}
                ></i></>
              }
              {
                !value.max && <div className="watermark">{React.language('timeEnd')}</div>
              }
            </div>
            <div className='line' ></div>
          </div>
          <div className="content-main">
            <div className="datePicker-content">
              <div className='main-wrapper'  >
                <BsyDatePicker
                  key={"dd0-" + new Date().getTime()}
                  viewMode={this.viewMode}
                  theme={this.props.theme}
                  endDate={minMaxValue}
                  format={this.props.format}
                  hasTfoot={this.props.format === 'yyyy-MM-dd HH:mm:ss' ? true : false}
                  date={dayjsUtils.timeToTZ(value.min ? new Date(value.min) : new Date())}
                  onDateUpdate={(c, closeFloat) => {

                    const object = dayjsUtils.timeToLocal(c);
                    c = object.date.getTime();
                    c = that.getRValue(c, 'min')
                    this.minRealValue = object.dateStr;
                    this.setState({
                      maxMinValue: c,
                      value: {
                        min: c,
                        max: this.state.value.max
                      }
                    }, () => {
                      BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
                    })
                  }}

                  onDateClear={() => {
                    this.setState({
                      maxMinValue: null,
                      value: {
                        min: null,
                        max: this.state.value.max
                      }
                    }, () => {
                      BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
                    })
                  }}

                />

              </div>
              <div className='main-wrapper'  >
                <BsyDatePicker
                  key={"dd1-" + new Date().getTime()}
                  viewMode={this.viewMode}
                  startDate={maxMinValue}
                  theme={this.props.theme}
                  format={this.props.format}
                  hasTfoot={this.props.format === 'yyyy-MM-dd HH:mm:ss' ? true : false}
                  date={dayjsUtils.timeToTZ(value.max ? new Date(value.max) : new Date())}
                  onDateUpdate={(c, closeFloat) => {
                    const object = dayjsUtils.timeToLocal(c);
                    c = object.date.getTime();
                    c = that.getRValue(c, 'max')
                    this.maxRealValue = object.dateStr;
                    this.setState({
                      minMaxValue: c,
                      value: {
                        max: c,
                        min: this.state.value.min
                      }
                    }, () => {
                      BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
                    })

                  }}

                  onDateClear={() => {
                    this.setState({
                      minMaxValue: null,
                      value: {
                        max: null,
                        min: this.state.value.min
                      }
                    }, () => {
                      BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
                    })


                  }}

                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
